import { LocalizedForm } from "common/localization";

export default class AdminProducerForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "name",
                    label: "ADMINISTRATION.PRODUCER.EDIT.FIELDS.NAME_LABEL",
                    placeholder: "ADMINISTRATION.PRODUCER.EDIT.FIELDS.NAME_PLACEHOLDER",
                    rules: "required|string",
                },
            ],
        };
    }
}
